export default {
    transFormDataToData(formData) {
        if (!(formData instanceof FormData)) return;
        function dataToObject(key_set, value, obj) {
            if (obj === undefined) obj = {};
            if (!(key_set instanceof Array)) return;
            let key = key_set.shift();
            if (key_set.length === 0) obj[key] = value;
            else {
                if (!obj.hasOwnProperty(key)) {
                    if (/^\d+$/.test(key_set[0])) obj[key] = [];
                    else obj[key] = {};
                }
                dataToObject(key_set, value, obj[key]);
            }
            return obj;
        }
        let result = {};
        for (let item of formData.entries()) {
            if (!item) return;
            let key = item[0], value = item[1];
            key = key.match(/([^\[\]]+)/g);
            dataToObject(key, value, result);
        }
        return result;
    },
    transDataToFormData(data, formData, prefix = '') {
        if (formData === undefined) formData = new FormData();
        Object.keys(data).forEach(key => {
            let fieldname = prefix ? `${prefix}[${key}]` : key;
            let value = data[key];
            if (value === null || value === undefined) return;
            if (typeof value !== 'object' || value instanceof File) formData.append(fieldname, value);
            else this.transDataToFormData(value, formData, fieldname);
        });
        return formData;
    },
    toDashString(inupt = '') {
        if (typeof input !== 'string') return;
        return input.match(/([0-Z]?([a-z]+)?)/g)
            .filter(str => !!str)
            .map(str => str.toLowerCase())
            .join('-');
    },
    inverseDashString(input = '') {
        if (typeof input !== 'string') return;
        return input.match(/([0-z]+)/g)
            .map(str => str[0].toUpperCase() + str.substr(1))
            .join('');
    },
    cloneVariable(obj = {}, deep = false) {
        if (obj === undefined || obj === null) return obj;
        if (typeof obj === 'object') {
            let result;
            if (obj instanceof Array) result = [];
            else result = {};
            Object.keys(obj).forEach(key => {
                if (deep) result[key] = this.cloneVariable(obj[key], deep);
                else result[key] = obj[key];
            });
            return result;
        } else {
            return obj;
        }
    }
};